import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function NotFound() {
    const navigate = useNavigate();
    const { lang } = useParams(); // Get the language from the URL

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate(`/${lang || 'en'}/home`); // Redirect to the correct home based on language
        }, 5000); // Redirect after 5 seconds

        return () => clearTimeout(timer);
    }, [navigate, lang]);

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404</h1>
            <p>Page not found. Redirecting to Home in 5 seconds...</p>
        </div>
    );
}
